export default __webpack_public_path__ + "static/media/805193261173178418.314f4e3d.png";